module.exports = __webpack_public_path__ + "img/139.f2c297e4.jpg";